var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 5.28125H14V3.65625C14 3.43281 13.82 3.25 13.6 3.25H12.8C12.58 3.25 12.4 3.43281 12.4 3.65625V5.28125H10.8C10.58 5.28125 10.4 5.46406 10.4 5.6875V6.5C10.4 6.72344 10.58 6.90625 10.8 6.90625H12.4V8.53125C12.4 8.75469 12.58 8.9375 12.8 8.9375H13.6C13.82 8.9375 14 8.75469 14 8.53125V6.90625H15.6C15.82 6.90625 16 6.72344 16 6.5V5.6875C16 5.46406 15.82 5.28125 15.6 5.28125ZM5.6 6.5C7.3675 6.5 8.8 5.04512 8.8 3.25C8.8 1.45488 7.3675 0 5.6 0C3.8325 0 2.4 1.45488 2.4 3.25C2.4 5.04512 3.8325 6.5 5.6 6.5ZM7.84 7.3125H7.4225C6.8675 7.57149 6.25 7.71875 5.6 7.71875C4.95 7.71875 4.335 7.57149 3.7775 7.3125H3.36C1.505 7.3125 0 8.84102 0 10.725V11.7812C0 12.4541 0.5375 13 1.2 13H10C10.6625 13 11.2 12.4541 11.2 11.7812V10.725C11.2 8.84102 9.695 7.3125 7.84 7.3125Z",
    fill: "#503EB6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.b0cd8584f17126a6ef20eaffd44e27bf.svg";
export { ForwardRef as ReactComponent };